import React, { forwardRef } from 'react';
import { BoxIcon } from 'lucide-react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: BoxIcon;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  icon: Icon,
  className = '',
  id,
  ...props
}, ref) => {
  const inputId = id || props.name || Math.random().toString(36).substring(7);
  return <div className="w-full flex flex-col gap-1.5" data-id="element-220">
        {label && <label htmlFor={inputId} className="text-sm font-bold text-slate-700 ml-1" data-id="element-221">
            {label}
          </label>}

        <div className="relative" data-id="element-222">
          {Icon && <div className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" data-id="element-223">
              <Icon size={20} data-id="element-224" />
            </div>}

          <input ref={ref} id={inputId} className={`
              w-full bg-white border-2 transition-colors duration-200
              rounded-2xl py-3.5 px-4 text-slate-800 placeholder:text-slate-400
              focus:outline-none focus:ring-0
              ${Icon ? 'pl-11' : ''}
              ${error ? 'border-pink-300 focus:border-pink-500 bg-pink-50/30' : 'border-slate-100 focus:border-emerald-400 hover:border-slate-200'}
              ${className}
            `} {...props} data-id="element-225" />
        </div>

        {error && <p className="text-sm text-pink-500 font-medium ml-1 mt-0.5 animate-in fade-in slide-in-from-top-1" data-id="element-226">
            {error}
          </p>}
      </div>;
});
Input.displayName = 'Input';